type ContactData = {
  PhoneNumber: string;
  StreetAddress: string;
  PostalCode: string;
  City: string;
};

type SiteMetadata = {
  title: string;
  siteUrl: string;
};

const CLINIC_EMAIL = 'palvelut@aatosklinikka.fi';
const GEO = { latitude: 60.2052, longitude: 24.9384 };
const MEDICAL_SPECIALTIES = ['Psychiatry', 'Psychology'];
const AVAILABLE_SERVICES = [
  'Lasten ja nuorten psykiatria',
  'Psykologipalvelut',
  'Psykoterapia',
  'Perheterapia',
  'Pariterapia',
];

function formatPhoneE164(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('358')) return `+${digits}`;
  if (digits.startsWith('0')) return `+358${digits.slice(1)}`;
  return `+${digits}`;
}

export function buildMedicalClinicSchema(
  contact: ContactData,
  siteMetadata: SiteMetadata
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'MedicalClinic',
    name: siteMetadata.title,
    url: siteMetadata.siteUrl,
    telephone: formatPhoneE164(contact.PhoneNumber),
    email: CLINIC_EMAIL,
    address: {
      '@type': 'PostalAddress',
      streetAddress: contact.StreetAddress,
      postalCode: contact.PostalCode,
      addressLocality: contact.City,
      addressCountry: 'FI',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: GEO.latitude,
      longitude: GEO.longitude,
    },
    medicalSpecialty: MEDICAL_SPECIALTIES,
    availableService: AVAILABLE_SERVICES,
  };
}
